import { notificationGetters } from '@/store/modules/notification/routines'

export default {
  [notificationGetters.NOTIFICATION_CONFIG]: state => state.notificationConfig
}
